/**
 * Provador Virtual + Tabela de Medidas — Cavasta
 * assets/provador-virtual.js
 *
 * Vanilla JS — sem dependências. Carregado só em páginas de produto.
 * Estética inspirada no provador da Alto (modal 2 colunas).
 *
 * Regra de ouro: NUNCA recomendar um número que não existe/está esgotado.
 * Sempre sugere o disponível mais próximo do ideal e avisa.
 */
(function () {
  'use strict';

  function cssAttr(s) { return String(s).replace(/(["\\])/g, '\\$1'); }
  function toNum(v) {
    if (v == null) return NaN;
    var m = String(v).replace(',', '.').match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  function openOverlay(overlay) {
    if (!overlay) return;
    overlay.removeAttribute('hidden');
    overlay.offsetHeight;
    overlay.classList.add('pv-overlay--visible');
    document.body.style.overflow = 'hidden';
    var first = overlay.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (first) { try { first.focus(); } catch (e) {} }
  }
  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.remove('pv-overlay--visible');
    var done = function () { overlay.setAttribute('hidden', ''); overlay.removeEventListener('transitionend', done); };
    overlay.addEventListener('transitionend', done);
    setTimeout(function () { if (!overlay.classList.contains('pv-overlay--visible')) overlay.setAttribute('hidden', ''); }, 400);
    document.body.style.overflow = '';
  }

  function initInstance(wrapper) {
    if (wrapper.dataset.pvReady === '1') return;
    wrapper.dataset.pvReady = '1';

    var sid = wrapper.dataset.sectionId;
    if (!sid) return;

    var btnOpenFitter = wrapper.querySelector('[data-pv-open-fitter]');
    var btnOpenTable  = wrapper.querySelector('[data-pv-open-table]');
    var modalFitter   = document.getElementById('pv-modal-fitter-' + sid);
    var modalTable    = document.getElementById('pv-modal-table-' + sid);

    var data = { hasSize: false, sizeOptionName: '', sizeOptionPosition: 0, sizes: [], variants: [], forma: 'normal', cmTable: {}, totalSteps: 2 };
    try {
      var dataEl = document.querySelector('script[data-pv-data="' + cssAttr(sid) + '"]');
      if (dataEl) data = Object.assign(data, JSON.parse(dataEl.textContent));
    } catch (e) { console.warn('[Provador Virtual] dados inválidos:', e); }

    var forma = wrapper.dataset.forma || data.forma || 'normal';
    var pos = parseInt(data.sizeOptionPosition, 10) || 1;

    function sizeAvailable(sizeStr) {
      return (data.variants || []).some(function (v) {
        var ov = v.options && v.options[pos - 1];
        return String(ov) === String(sizeStr) && v.available;
      });
    }
    var sizeModel = (data.sizes || []).map(function (s) {
      return { str: String(s), num: toNum(s), available: sizeAvailable(s) };
    }).filter(function (s) { return !isNaN(s.num); });

    /* ── Recomendação: encaixa no disponível mais próximo ── */
    function snapToAvailable(ideal) {
      var avail = sizeModel.filter(function (s) { return s.available; });
      var pool = avail.length ? avail : sizeModel;
      if (!pool.length) return { none: true, ideal: ideal };
      var best = pool.slice().sort(function (a, b) {
        var da = Math.abs(a.num - ideal), db = Math.abs(b.num - ideal);
        if (da !== db) return da - db;
        return b.num - a.num; // empate: prefere o MAIOR (evita aperto)
      })[0];
      return { none: false, ideal: ideal, size: best.str, num: best.num, exact: best.num === ideal, soldOutOnly: avail.length === 0 };
    }
    function computeFromChoices() {
      var ideal = parseInt(state.choices.numero, 10);
      if (forma === 'pequena') ideal += 1; else if (forma === 'grande') ideal -= 1;
      if (state.choices.servir === 'apertado') ideal += 1; else if (state.choices.servir === 'folgado') ideal -= 1;
      return snapToAvailable(ideal);
    }
    function cmToSize(cm) {
      var entries = Object.keys(data.cmTable || {}).map(function (k) {
        return { num: parseInt(k, 10), cm: toNum(data.cmTable[k]) };
      }).filter(function (e) { return !isNaN(e.num) && !isNaN(e.cm); }).sort(function (a, b) { return a.cm - b.cm; });
      if (!entries.length) return NaN;
      for (var i = 0; i < entries.length; i++) { if (entries[i].cm >= cm) return entries[i].num; }
      return entries[entries.length - 1].num;
    }

    /* ── Seleção da variante (radio / popout / select) ── */
    function pickVariant(sizeStr) {
      var list = (data.variants || []).filter(function (v) { return v.options && String(v.options[pos - 1]) === String(sizeStr); });
      return list.filter(function (v) { return v.available; })[0] || list[0] || null;
    }
    function selectSize(sizeStr) {
      var form = wrapper.closest('form[data-product-form]') || wrapper.closest('form') ||
                 document.querySelector('form[data-product-form]') || document.querySelector('.product__form') || document;
      var nameSel = 'options[' + data.sizeOptionName + ']';
      var radio = form.querySelector('input.radio__input[name="' + cssAttr(nameSel) + '"][value="' + cssAttr(sizeStr) + '"]') ||
                  form.querySelector('input[data-single-option-selector][name="' + cssAttr(nameSel) + '"][value="' + cssAttr(sizeStr) + '"]');
      if (radio) { radio.checked = true; radio.click(); radio.dispatchEvent(new Event('change', { bubbles: true })); return true; }
      var hidden = form.querySelector('input[data-single-option-selector][name="' + cssAttr(nameSel) + '"]');
      if (hidden) {
        var container = hidden.closest('[data-popout]') || form;
        var opt = container.querySelector('[data-popout-option][data-value="' + cssAttr(sizeStr) + '"]');
        if (opt) { opt.click(); return true; }
        hidden.value = sizeStr; hidden.dispatchEvent(new Event('change', { bubbles: true })); return true;
      }
      var variant = pickVariant(sizeStr);
      var sel = form.querySelector('select[name="id"]');
      if (variant && sel) { sel.value = String(variant.id); sel.dispatchEvent(new Event('change', { bubbles: true })); return true; }
      return false;
    }

    /* ── Tabela de medidas (independente do provador) ── */
    if (btnOpenTable && modalTable) btnOpenTable.addEventListener('click', function () { openOverlay(modalTable); });
    [modalFitter, modalTable].forEach(function (modal) {
      if (!modal) return;
      modal.querySelectorAll('[data-pv-close]').forEach(function (b) { b.addEventListener('click', function () { closeOverlay(modal); }); });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeOverlay(modal); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      [modalFitter, modalTable].forEach(function (m) { if (m && !m.hasAttribute('hidden')) closeOverlay(m); });
    });

    if (!modalFitter) return;

    /* ── UI ── */
    var total = parseInt(data.totalSteps, 10) || 2;
    var state = { index: 0, choices: { sexo: null, numero: null, servir: null }, rec: null };
    var panels     = modalFitter.querySelectorAll('[data-panel]');
    var stepPanels = [].slice.call(panels).filter(function (p) { return p.dataset.panel !== 'result'; });
    var stepIndic  = modalFitter.querySelector('[data-pv-stepindic]');
    var navBar     = modalFitter.querySelector('[data-pv-nav]');
    var btnBack    = modalFitter.querySelector('[data-pv-back]');
    var resultNum  = modalFitter.querySelector('[data-pv-result-number]');
    var resultSub  = modalFitter.querySelector('[data-pv-result-sub]');
    var warnBox    = modalFitter.querySelector('[data-pv-result-warn]');
    var warnText   = modalFitter.querySelector('[data-pv-result-warn-text]');
    var btnSelect  = modalFitter.querySelector('[data-pv-select-size]');
    var btnRestart = modalFitter.querySelector('[data-pv-restart]');
    var cmInput    = modalFitter.querySelector('[data-pv-cm-input]');
    var cmSubmit   = modalFitter.querySelector('[data-pv-cm-submit]');
    var cmError    = modalFitter.querySelector('[data-pv-cm-error]');

    function showStep(target) {
      panels.forEach(function (p) { p.classList.add('pv-panel--hidden'); });
      if (target === 'result') {
        var rp = modalFitter.querySelector('[data-panel="result"]');
        if (rp) rp.classList.remove('pv-panel--hidden');
        if (stepIndic) stepIndic.setAttribute('hidden', '');
      } else {
        if (stepPanels[target]) stepPanels[target].classList.remove('pv-panel--hidden');
        if (stepIndic) { stepIndic.removeAttribute('hidden'); stepIndic.textContent = 'Passo ' + (target + 1) + ' de ' + total; }
      }
      if (navBar) navBar.toggleAttribute('hidden', target === 0 || target === 'result');
      state.index = target;
    }

    function showResult(rec) {
      state.rec = rec;
      if (rec.none) {
        if (resultNum) resultNum.textContent = '—';
        if (resultSub) resultSub.textContent = 'Este produto está sem numeração disponível no momento.';
        if (warnBox) warnBox.setAttribute('hidden', '');
        if (btnSelect) btnSelect.setAttribute('disabled', '');
      } else {
        if (btnSelect) btnSelect.removeAttribute('disabled');
        if (resultNum) resultNum.textContent = rec.size;
        if (rec.exact && !rec.soldOutOnly) {
          if (resultSub) resultSub.textContent = 'Com base no seu perfil, este é o número que melhor se encaixa neste modelo.';
          if (warnBox) warnBox.setAttribute('hidden', '');
        } else {
          if (resultSub) resultSub.textContent = 'Ajustamos a recomendação para a numeração deste modelo.';
          if (warnBox && warnText) {
            warnBox.removeAttribute('hidden');
            warnText.textContent = rec.soldOutOnly
              ? ('O número mais próximo do seu (' + rec.ideal + ') está esgotado. Mostramos a opção existente mais próxima — confira a disponibilidade.')
              : ('O ideal seria ' + rec.ideal + ', mas neste modelo o disponível mais próximo é ' + rec.size + '.');
          }
        }
      }
      showStep('result');
    }

    function goNext() {
      if (typeof state.index === 'number' && state.index < stepPanels.length - 1) {
        showStep(state.index + 1);
      } else {
        showResult(computeFromChoices());
      }
    }

    modalFitter.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pv-choice]');
      if (!btn) return;
      var choice = btn.dataset.pvChoice;
      modalFitter.querySelectorAll('[data-pv-choice="' + cssAttr(choice) + '"]').forEach(function (s) { s.classList.remove('pv-option--selected'); });
      btn.classList.add('pv-option--selected');
      state.choices[choice] = btn.dataset.value;
      setTimeout(goNext, 180);
    });

    /* ── Caminho: comprimento do pé (cm) → resultado direto ── */
    function submitCm() {
      var cm = toNum(cmInput && cmInput.value);
      if (isNaN(cm) || cm < 18 || cm > 35) {
        if (cmError) cmError.removeAttribute('hidden');
        if (cmInput) cmInput.focus();
        return;
      }
      if (cmError) cmError.setAttribute('hidden', '');
      var ideal = cmToSize(cm);
      if (isNaN(ideal)) return;
      showResult(snapToAvailable(ideal));
    }
    if (cmSubmit) cmSubmit.addEventListener('click', submitCm);
    if (cmInput) cmInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitCm(); } });

    if (btnBack) btnBack.addEventListener('click', function () {
      if (typeof state.index === 'number' && state.index > 0) showStep(state.index - 1);
    });

    if (btnSelect) btnSelect.addEventListener('click', function () {
      if (state.rec && !state.rec.none) selectSize(state.rec.size);
      closeOverlay(modalFitter);
    });

    function resetFitter() {
      state.choices = { sexo: null, numero: null, servir: null };
      state.index = 0; state.rec = null;
      modalFitter.querySelectorAll('.pv-option--selected').forEach(function (el) { el.classList.remove('pv-option--selected'); });
      if (warnBox) warnBox.setAttribute('hidden', '');
      if (cmError) cmError.setAttribute('hidden', '');
      if (cmInput) cmInput.value = '';
      if (btnSelect) btnSelect.removeAttribute('disabled');
      showStep(0);
    }
    if (btnRestart) btnRestart.addEventListener('click', resetFitter);

    if (btnOpenFitter) btnOpenFitter.addEventListener('click', function () { resetFitter(); openOverlay(modalFitter); });
  }

  function init() { document.querySelectorAll('[id^="pv-wrapper-"]').forEach(initInstance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
